import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ResaleTickets from '../../sso/components/forms/resale-tickets/ResaleTickets';
import * as userAccountActions from '../../sso/store/actions/user-account-actions';

class TicketResaleSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userAccountData: {}
        };

        this.refreshResaleComponent = this.refreshResaleComponent.bind(this);
    }

    componentDidMount() {
        this.refreshResaleComponent(true);
    }

    refreshResaleComponent(shouldRefreshComponent) {
        const { actions, formData } = this.props;
        const { getUserDataCallbackUrl } = formData;

        actions.getUserAccountData(getUserDataCallbackUrl, shouldRefreshComponent);
    }

    render() {
        const { formData, userAccountData } = this.props;

        return (
            <div className='ticket-resale-section__content'>
                <ResaleTickets 
                    formData={formData}
                    accountData={userAccountData}
                />
            </div>
        );
    }
}

TicketResaleSection.propTypes = {
    formData: PropTypes.object
};

function mapStateToProps(state) {
    return {
        isUserNotSignedIn: state.userAccount.isUserNotSignedIn,
        isUserAccountDataLoadedSuccessful: state.userAccount.isUserAccountDataLoadedSuccessful,
        isAccountPageRefresh: state.userAccount.isAccountPageRefresh,
        userAccountData: state.userAccount.userAccountData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            getUserAccountData: bindActionCreators(userAccountActions.getUserAccountData, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketResaleSection);
